import { cn } from '@/lib/utils';

/** Anneau de focus de l'espace createur (2 px indigo, decale). */
export const FOCUS_RING = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4B47C4] focus-visible:ring-offset-2';

export interface SheetAnchor {
  /** Distance du haut de la fenetre au bas du declencheur (px). */
  top: number;
  /** Distance du bord droit de la fenetre au bord droit du declencheur (px). */
  right: number;
}

/** Position d'un menu sous son declencheur, aligne a droite. */
export function anchorFrom(el: HTMLElement): SheetAnchor {
  const r = el.getBoundingClientRect();
  return { top: r.bottom + 8, right: Math.max(16, window.innerWidth - r.right) };
}

/** Entree de feuille rendue par un lien (meme gabarit que SheetRow). */
export const SHEET_ROW_CLASS = cn(
  'flex min-h-[52px] w-full items-center gap-3 px-3.5 py-1.5 text-left no-underline hover:bg-[#F7F6FD]',
  FOCUS_RING,
  'focus-visible:ring-inset focus-visible:ring-offset-0',
);

/** « « Poupée qui parle » : position 2 sur 4 » (annonce aria-live). */
export function positionMessage(name: string, index: number, total: number): string {
  return `«\u00A0${name}\u00A0»\u00A0: position ${index + 1} sur ${total}`;
}

export interface ReservedLabelItem {
  status: 'available' | 'reserved' | 'partial';
  quantity: number;
  reservationCount: number;
  isReservedByOwner: boolean;
  donors?: string[];
}

/** « Réservé par Sophie (1 sur 2) », « Réservé par vous », « Réservé ». */
export function reservedLabel(item: ReservedLabelItem): string {
  if (item.isReservedByOwner && item.reservationCount === 0) return 'Réservé par vous';
  const names = (item.donors ?? []).filter(Boolean);
  const who = names.length === 0 ? '' : names.length <= 2 ? ` par ${names.join(' et ')}` : ` par ${names[0]} et ${names.length - 1} autres`;
  const part = item.quantity > 1 && item.status === 'partial' ? ` (${item.reservationCount} sur ${item.quantity})` : '';
  return `Réservé${who}${part}`;
}
